<template>
  <div>
    <b-card>
      <page-title v-if="titleStatus" :title="$t('jockeys.items')" />

      <main-table
        :fields="fields"
        :list_url="'admin/jockey'"
        :reloadData="reloadData"
        :params="filter"
        :createBtnLabel="$t('jockeys.create')"
        createRouteName="contributor.jockeyCreate"
        :excelFields="excelFields"
        excelName="jockeys"
        :downloadSampleStatus="true"
        downloadSampleUrl="jockey/excel-sample"
        :uploadFileStatus="true"
        uploadFileUrl="jockey/excel"
      />
    </b-card>
  </div>
</template>
<script>
import { core } from "../../../../config/pluginInit";
import JockeyFilter from "../models/JockeyFilter";
import searchMixin from "../../../../Mixins/searchMixin";

export default {
  mixins: [searchMixin],
  data() {
    return {
      filter: new JockeyFilter(),
      fields: [
        this.$t("global.selected"),
        { key: "id", label: this.$t("table.id"), sortable: true },
        { key: "name", label: this.$t("table.name"), sortable: true },
        {
          key: "actions",
          label: this.$t("table.actions"),
          type: "actions",
          actions: [
            {
              text: this.$t("global.view"),
              icon: "fas fa-eye",
              color: "info",
              ifNavigate: true,
              routeName: "contributor.jockeyView",
              routeParams: ["id"],
            },
            {
              text: this.$t("global.update"),
              icon: "fas fa-pen",
              color: "primary",
              ifNavigate: true,
              routeName: "contributor.jockeyUpdate",
              routeParams: ["id"],
            },
            {
              text: this.$t("global.delete"),
              icon: "fas fa-trash-alt",
              color: "danger",
              showAlert: true,
              actionHeader: this.$t("global.delete"),
              titleHeader: this.$t("jockeys.item"),
              textContent: "name",
              url: "admin/jockey",
              type: "delete",
            },
          ],
        },
      ],
      excelFields: {
        [this.$t("table.id")]: "id",
        [this.$t("table.name")]: "name",
        [this.$t("table.createdAt")]: "created_at",
      },
    };
  },
  mounted() {
    core.index();
  },
};
</script>
